import styled from 'styled-components';
import colors from 'Styles/colors';
import { slideInRight } from 'Styles/effects';

export const Wrapper = styled.div`
  background: ${({ theme }) => theme.backgrounds.modal};
  text-align: left;
  line-height: 1.44;
  border: solid 1px ${({ theme }) => theme.backgrounds.modal};
  max-width: ${(props) => props.maxWidth};
  padding: 55px !important;
  display: flex;
  flex-direction: column;
`;
Wrapper.displayName = 'Wrapper';

export const PrimaryTitle = styled.div`
  font-size: 21.5px;
  font-weight: 600;
  margin-bottom: 28px;
  color: ${({ theme }) => theme.text.modalTitle2};
`;
PrimaryTitle.displayName = 'PrimaryTitle';

export const SecondaryTitle = styled.div`
  font-size: 17.5px;
  font-weight: 500;
  margin-bottom: 12px;
  color: ${({ theme }) => theme.text.modalTitle2};
`;
SecondaryTitle.displayName = 'SecondaryTitle';

export const TertiaryTitle = styled.a`
  cursor: pointer;
  font-size:15px;
  font-weight: 500;
  color: ${colors.blueCerulean};
`;
TertiaryTitle.displayName = 'TertiaryTitle';

export const Text = styled.div`
  font-size:13.5px;
  color: ${colors.grey19}
`;
Text.displayName = 'Text';

export const Logo = styled.img`
  width: fit-content;
  height: 35px;
  margin-bottom: 18px;
`;
Logo.displayName = 'Logo';

export const Row = styled.div`
  margin-bottom: 12px;
`;
Row.displayName = 'Row';

export const Container = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  width: auto;
  max-height: 22vw;
  padding-right: 14px;
`;
Container.displayName = 'Container';

export const Button = styled.div`
  border: 0;
  color: white;
  text-align: center;
  min-width: 89px;
  max-width: fit-content;
  width: auto;
  height: 34px;
  line-height: 24px;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 500;
  padding: 5px;
  cursor: pointer;
  display: inline-block;
  background-color: ${colors.blueCerulean};
  align-self: flex-end;
  margin-top: 34px;
`;
Button.displayName = 'Button';

export const UserContainer = styled.div`
  position: relative;
  width: 100%;
  margin-top: auto;
`;
UserContainer.displayName = 'UserContainer';

export const UserTrigger = styled.div`
  position: relative;
  width: 100%;
  min-height: 42px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 8px 12px 8px 23px;
  cursor: pointer;
`;
UserTrigger.displayName = 'UserTrigger';

export const AvatarSlot = styled.div`
  position: relative;
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
`;
AvatarSlot.displayName = 'AvatarSlot';

export const UserInfo = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  margin-left: 13px;
  display: flex;
  flex-direction: column;
  ${slideInRight}
`;
UserInfo.displayName = 'UserInfo';

export const UserName = styled.div`
  font-weight: 600;
  color: ${({ theme }) => theme.buttons.sidebar.text};
  font-size: 12px;
  font-style: normal;
  line-height: normal;
`;
UserName.displayName = 'UserName';

export const UserInfoText = styled.p`
  color: ${({ theme }) => theme.buttons.sidebar.textSecondary};
  font-size: 10px;
  font-style: normal;
  line-height: normal;
`;
UserInfoText.displayName = 'UserInfoText';
